module.exports = __webpack_public_path__ + "img/RafaelAlfaro.25292f83.png";